import { render } from "./CultureDetail.vue?vue&type=template&id=156b3e7c"
import script from "./CultureDetail.vue?vue&type=script&lang=js"
export * from "./CultureDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\item\\jts\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__